import React, { useState } from 'react';
import PageHeader from '@features/shared/components/PageHeader';
import Loader from "@features/shared/components/Loader";
import "./DRMDetails.css"
import { useLocation } from "react-router-dom";

function DRMDetails() {
    const [loading] = useState(false);
    const location = useLocation();
    const meetingDetails = location.state;

    return (
        <div>
            <Loader loading={loading} />
            <PageHeader title="DRM Meeting Details" path="/drm-meeting-approval" />
            <>
                <div className='drmDetails__OuterBox'>
                    <div className='drmDetails__innerBox'>
                        {meetingDetails?.Zone__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Zone: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Zone__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Town_name__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Town Name: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Town_name__c}</div>
                            </div>
                        )}
                        {meetingDetails?.TSI_Territory_Name__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>TSI Territory Name: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.TSI_Territory_Name__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Cluster_Name__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Cluster Name: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Cluster_Name__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Customer_Name__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Customer Name: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Customer_Name__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Objective_of_meet__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Objective of meet: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Objective_of_meet__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Type_of_DRM__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Type of DRM: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Type_of_DRM__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Town_Selection_criteria__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Town Selection criteria: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Town_Selection_criteria__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Dealer_Selection_Criteria__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Dealer Selection Criteria: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Dealer_Selection_Criteria__c}</div>
                            </div>
                        )}
                        {meetingDetails?.If_Category_Specific_dealers_then_which__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>If Category Specific dealers then which: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.If_Category_Specific_dealers_then_which__c}</div>
                            </div>
                        )}
                        {meetingDetails?.No_of_PCC_dealers_in_town__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>No of PCC dealers in town: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.No_of_PCC_dealers_in_town__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Estimated_no_of_Dealers_to_Participate__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Estimated no of Dealers to Participate: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Estimated_no_of_Dealers_to_Participate__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Total_Head_Count_Dealer__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Dealer Head Count: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Total_Head_Count_Dealer__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Total_Head_Count_Employee__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Employee Head Count: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Total_Head_Count_Employee__c}</div>
                            </div>
                        )}
                        {meetingDetails?.No_of_Dealers_invited__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>No of Dealers Invited: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.No_of_Dealers_invited__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Reason_for_exceeding_Budget__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Reason for Exceeding Budget: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Reason_for_exceeding_Budget__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Primary_Reason_for_DRM__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Primary reason for DRM: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Primary_Reason_for_DRM__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Budget_out_of_Pocket_expenses__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Budgeted Out-of-Pocket Expenses: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Budget_out_of_Pocket_expenses__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Total_Cost__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Total Cost: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Total_Cost__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Cost_Per_Head__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Cost Per Head: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Cost_Per_Head__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Tentative_date_of_the_meet__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Tentative date of the meet: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Tentative_date_of_the_meet__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Updated_Total_Cost__c !== undefined && meetingDetails?.Updated_Total_Cost__c !== null && meetingDetails?.Updated_Total_Cost__c !== 0 && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Updated Total Cost: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Updated_Total_Cost__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Updated_Cost_per_Head__c !== undefined && meetingDetails?.Updated_Cost_per_Head__c !== null && meetingDetails?.Updated_Cost_per_Head__c !== 0 && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Updated Cost Per Head: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Updated_Cost_per_Head__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Actual_Date_of_the_Meet__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Actual date of the meet: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Actual_Date_of_the_Meet__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Current_monthly_average_sales_of_Town__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Current monthly average sales of Town: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Current_monthly_average_sales_of_Town__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Post_DRM_monthly_average_sale_planned__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Post DRM monthly average sale planned : </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Post_DRM_monthly_average_sale_planned__c}</div>
                            </div>
                        )}
                        {meetingDetails?.Actual_out_of_pocket_expenses__c !== undefined && meetingDetails?.Actual_out_of_pocket_expenses__c !== null && meetingDetails?.Actual_out_of_pocket_expenses__c !== 0 && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>Actual out of pocket expenses: </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.Actual_out_of_pocket_expenses__c}</div>
                            </div>
                        )}
                        {meetingDetails?.ZSM_Status__c && meetingDetails?.isZSMCreated__c !== "true" && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>ZSM Status : </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.ZSM_Status__c}</div>
                            </div>
                        )}
                        {meetingDetails?.NSM_Status__c && (
                            <div className='drmDetails__despBox'>
                                <div className='drmDetails__despBoxName'>NSM Status : </div>
                                <div className='drmDetails__despBoxValue'>{meetingDetails.NSM_Status__c}</div>
                            </div>
                        )}
                    </div>
                </div>
            </>
        </div>
    );
}
export default DRMDetails;